import React, {Component} from 'react';
import './enter-email-css.css';
import {Link} from 'react-router-dom';
import {verify, emailVerified} from '../../../functions/verifyEmail';

export default class EnterEmail extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        verify();
        emailVerified()
    };
    render() {
        return (
            <div id="en-d">
                <div id="en-d3a">
                    <div id="en-d1a">
                        <Link to="/verify">
                            <div id="en-d2a">
                                Verify
                            </div>
                        </Link>
                    </div>
                    <div id="en-d1c">
                        <Link to="/verified">
                            <div id="en-d2b">
                                Verified
                            </div>
                        </Link>
                    </div>
                </div>
                <div id="en-d1b">
                    <h1>Enter Email</h1>
                </div>
                <div id="en-d4b">
                    <div id="en-d4a">
                        <form onSubmit={this.handleSubmit}>
                            <label id="en-l1a">Email</label>
                            <input id="en-i1a"
                                   ref={(email) => this.email = email}
                                   type="text"
                                   placeholder="Email"/>
                            <button type="submit">
                                Enter
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/auth/verify/EnterEmail.js